export default "__VITE_ASSET__ZmqiE1kw__"